document.addEventListener("teeinblue-event-after-cart-added", () => {
  const minimogCartDrawer = document.querySelector('m-cart-drawer');
  if (minimogCartDrawer) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function(){
          minimogCartDrawer.open()
      },1500)
  }

  var request = new XMLHttpRequest();
  request.open('GET', '/cart.js', true);
  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      var itemCount = data.item_count;
      var cartCount = document.querySelectorAll('m-cart-count');
      if (cartCount.length) {
        cartCount.forEach(function(cartCountItem) {
          if(data.item_count === 0) {
            cartCountItem.classList.add('m:hidden');
          } else {
            cartCountItem.classList.remove('m:hidden');
            cartCountItem.innerText = itemCount;
          }
        });
      }
    }
  };
  request.send();
})